export const ZENDESK_SSO_BRIDGE_PATH = "zendesk-sso-bridge";
